export const SUBMIT_TITLE = "SUBMIT_TITLE";
export const SUBMIT_TITLE_SUCCESS = "SUBMIT_TITLE_SUCCESS";
export const SUBMIT_TITLE_FAILED = "SUBMIT_TITLE_FAILED";
export const CLEAR_TITLE_CHECK_ERROR = "CLEAR_TITLE_CHECK_ERROR";
export const REMOVE_TITLE_RESPONSE = "REMOVE_TITLE_RESPONSE";
export const SET_OPEN_SALVAGE_ALERT = "SET_OPEN_SALVAGE_ALERT";
export const SET_MOVE_TO_NEXT_TAB = "SET_MOVE_TO_NEXT_TAB";
export const CLEAR_TITLE_RESPONSE = "CLEAR_TITLE_RESPONSE";
export const DOWNLOAD_TITLE_OUTPUT = "DOWNLOAD_TITLE_OUTPUT";
export const DOWNLOAD_TITLE_OUTPUT_SUCCESS = "DOWNLOAD_TITLE_OUTPUT_SUCCESS";
export const DOWNLOAD_TITLE_OUTPUT_FAILED = "DOWNLOAD_TITLE_OUTPUT_FAILED";
